import { AnyConceptStatusesByCid, ConceptStatusValueType, FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import {
	ConceptStatusUpdate,
	getConceptStatusValue,
	NeurologicWeaknessConcept,
	RNeurologicWeaknessItem,
} from "@fusion-advantage/formlib"
import { FormRootState, FormThunk } from "../../redux/formStore"
import { err, ok, Result } from "neverthrow"
import z from "zod"
import { ComplexModelReduxPersister } from "./ComplexModelReduxPersister"
import { setNeurologicWeaknessReview } from "../../redux/neurologicWeaknessReviewSlice"

export class NeurologicWeaknessReviewModelReduxPersister implements ComplexModelReduxPersister {
	loadFromStatuses = (statusesByCid: AnyConceptStatusesByCid): FormThunk<Result<void, FusionError>> => (dispatch) => {
		const valueForCid = (cid: string) => getConceptStatusValue(statusesByCid[cid])
		const modelsValue = valueForCid(NeurologicWeaknessConcept.cid)
		if(!modelsValue) {
			return ok()
		}
		const rParseModels = z.array(RNeurologicWeaknessItem).safeParse(modelsValue)
		if(!rParseModels.success) {
			return err(serializeFusionError('NeurologicWeaknessReviewModelReduxPersister parseModels', rParseModels.error))
		}
		dispatch(setNeurologicWeaknessReview(rParseModels.data))
		return ok()
	}
	shouldSave(prevState: FormRootState, nextState: FormRootState) {
		return prevState.neurologicWeaknessReview.models !== nextState.neurologicWeaknessReview.models
	}
	createStatusUpdates(nextState: FormRootState): ConceptStatusUpdate[] {
		return [{
			cid: NeurologicWeaknessConcept.cid,
			value: nextState.neurologicWeaknessReview.models,
			// must be .Chosen to be picked up by formDraftMiddleware
			// for auto draft save
			valueType: ConceptStatusValueType.Chosen,
		}]
	}
}
